import React, { useEffect } from 'react';
import TagCloud from 'TagCloud';

const CloudTagSphere = () => {
    useEffect(() => {
        const myTags = [
            'JavaScript', 'CSS', 'HTML', 'Sass', 'ExpressJS', 'React', 
            'Bootstrap', 'MaterialUI', 'GitHub', 'Redux',
            'JWT', 'NodeJS', 'Firebase', 'TailwindCss', 'Mongodb',
        ];
        TagCloud('.content', myTags,{
    
            // radius in px
            radius: 180,
          
            // animation speed
            // slow, normal, fast
            maxSpeed: 'normal',
            initSpeed: 'normal',
          
            // 0 = top
            // 90 = left
            // 135 = right-bottom
            direction: 135,
            
            // interact with cursor move on mouse out
            keep: true
            
          });
          
          //To change the color of text randomly
          const colors = ['#34A853', '#FBBC05', '#4285F4', '#7FBC00', '#FFBA01', '#01A6F0'];
          const random_color = colors[Math.floor(Math.random() * colors.length)];
          document.querySelector('.content').style.color = random_color;
      },[]);

    return (
        <div className='h-[300px] md:h-[400px] relative overflow-hidden'  
        data-aos="fade-down"
        data-aos-easing="ease-out-cubic"
        data-aos-duration="2000"
        >
            <span className="content"></span>
        </div>
    );
};

export default CloudTagSphere;